import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { FolderIcon } from './FolderIcon';
export function FolderButton(_ref) {
  var foldersCount = _ref.foldersCount,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    size: "XS",
    beforeIcon: /*#__PURE__*/React.createElement(FolderIcon, null),
    theme: "fill_secondary"
  }, foldersCount);
}